import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  Form,
  FormGroup,
  TextInput,
  Tab,
  RadioButtonGroup,
  RadioButton,
  Tile,
  Link,
  Tabs,
  DatePicker,
  DatePickerInput,
  Toggle,
  Row,
  Column,
  TextArea,
  TabList,
  TabPanels,
  TabPanel,
  Loading,
} from '@carbon/react';
import StreamListItem from './StreamListItem';
import { Page } from 'components/Page';
import { PreviewSlideshow } from 'components/Elements';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormButtons } from 'components/Form';

import Assignments from './Assignments';
import { usePrevious } from 'components/Helpers';
import { SingleButton } from 'components/Form/FormButtons';

import "./_stream-page.scss";
import useUser from '@/lib/hooks/useUser';
import { prepare_form, useCreateStreamMutation, useLazyGetStreamQuery, useUpdateStreamMutation, validate_form } from '@/redux/new_services/stream';
import useModal from '@/lib/hooks/useModal';
import { openShowItemForm } from '@/redux/new_services/forms';
import { showToast } from '@/redux/new_services/toasts';

import moment from 'moment';
import 'moment/locale/de';
moment.locale('de');

const StreamPage = () => {
  const dispatch = useDispatch();

  const [showUnsavedWarning] = useModal('CLOSE_UNSAVED_FORM_MODAL');
  const [confirmRemoveStream] = useModal('DELETE_STREAM');

  const [createStream, { isLoading: isCreating }] = useCreateStreamMutation();
  const [updateStream, { isLoading: isSaving }] = useUpdateStreamMutation();

  const { id: currentId } = useParams();
  const [isNew, setIsNew] = useState(false);
  const prevId = usePrevious(currentId);

  const [
    trigger,
    {
      data,
      isLoading
    },
  ] = useLazyGetStreamQuery();

  const { isAdmin } = useUser();
  const [statableItem, setItem] = useState({
    items: [],
    orientation: 0,
    name: '',
  });

  const [unsaved, setUnsaved] = useState(false);

  const history = useNavigate();
  const location = useLocation();

  const load = useCallback(id => {
    trigger(id, true)
      .unwrap()
      .then(data => {
        //console.info("set Item after getting data:", data);
        //setItem(data.data);
      })
      .catch(error => {
        history("/streams", {replace: true});
        dispatch(showToast({kind: 'error', title: 'Fehler beim laden des Streams.', subtitle: 'untertitel'}));
        console.error('error ::', error);
      });
  }, [trigger, dispatch, history])

  useEffect(() => {

    console.info("set Item after getting data:", data);
    if (data) {
      setItem(data.data);
    }
  }, [data, setItem]);

  useEffect(() => {

    if (currentId !== prevId) {
      if (currentId !== 'new') {
        console.info("init effect, currentId is not new!", currentId);
        load(currentId);
        setIsNew(false);
      } else {
        console.info("we are new", currentId);
        setUnsaved(true);
        setIsNew(true);
      }
    } else {
      console.info("currentId is the same as prevId", currentId);
    }

  }, [currentId, prevId, load ]);

  const refreshElements = (e) => {
    changeFormField('items', e);
    setUnsaved(true);
  };

  const changeFormField = useCallback((field, value) => {
    setItem((s) => {
      return {
        ...s,
        [field]: value
      };
    });
    setUnsaved(true);
  }, [setItem, setUnsaved]);

  const editStreamItem = useCallback((itemID) => {
    dispatch(openShowItemForm(
      statableItem.items.find((s) => s.model.ID === itemID),
      statableItem.orientation,
      (item) => {
        setUnsaved(true);
        setItem((state) => {
          return {
            ...state,
            items: state.items.map((s) => {
              if (s.model.ID === item.model.ID) {
                console.info("update item:", item);
                return item;
              } else {
                return s;
              }
            }),
          };
        });
      },
    ));
  }, [dispatch, statableItem]);

  const submitForm = () => {
    let form = prepare_form({...statableItem});
    let validate = validate_form(form);
    console.info("validate:", validate);
    console.info("form:", form);
    if (currentId === 'new') {
      if (validate) {
        dispatch(showToast({kind: 'error', title: 'Fehler beim speichern.', subtitle: validate}));
      } else {
        createStream({form})
          .unwrap()
          .then(res => {
            console.info("res:", res);
            history(`/stream/${res.data.model.ID}`, {replace: true, preventScrollReset: true, state: {was_new: true}});
            dispatch(showToast({kind: 'success', title: 'Stream wurde erfolgreich erstellt.', subtitle: 'untertitel'}));
            setUnsaved(false);
          })
          .catch(err => {
            dispatch(showToast({kind: 'error', title: 'Fehler beim speichern.', subtitle: 'untertitel'}));
          });
      }
    } else {
      if (validate) {
        dispatch(showToast({kind: 'error', title: 'Fehhler beim ändern.', subtitle: validate}));
      } else {
        updateStream({id: currentId, form})
          .unwrap()
          .then(res => {

            console.info("res:", res);
            dispatch(showToast({kind: 'success', title: 'Stream wurde erfolgreich aktualisiert.', subtitle: 'untertitel'}));
            setUnsaved(false);
          })
          .catch(err => {
            dispatch(showToast({kind: 'error', title: 'Fehler beim aktualisieren.', subtitle: 'untertitel'}));
          });
      }
    }
  };

  const changeAssignments = (assingments) => {
    setUnsaved(true);
    setItem((state) => {
      return {
        ...state,
        devices: assingments.map((a) => ({ model: { ID: a } })),
      };
    });
  };

  const resetForm = () => {
    let back = -1;
    if (location.state?.was_new === true) {
      back = -2;
    }

    if (unsaved === true) {
      showUnsavedWarning({next: () => {
        history(back);
      }});
    } else {
      history(back);
    }
  };

  const removeStream = () => {
    confirmRemoveStream({stream: statableItem, cb: () => {
      history(-2);
    }})
  };

  const isSafari = false;

  // Estimated total playback time: sum the duration of every stream item.
  // Sub-streams (element_type === "stream") contribute the sum of their
  // inner items' durations so the operator gets a realistic picture of how
  // long one full loop will take. We fall back to 10 s for items without a
  // duration set — that matches the player's default.
  const estimatedDurationSeconds = useMemo(() => {
    const items = statableItem?.items || [];
    const itemDuration = (it) => {
      if (it?.element_type === 'stream' && Array.isArray(it?.element?.items)) {
        return it.element.items.reduce((sum, inner) => sum + (Number(inner?.duration) || 10), 0);
      }
      return Number(it?.duration) || 10;
    };
    return items.reduce((sum, it) => sum + itemDuration(it), 0);
  }, [statableItem?.items]);

  // Pretty-print "Xm Ys" / "Ys" — short and German-friendly.
  const formatDuration = (totalSeconds) => {
    if (!totalSeconds || totalSeconds < 1) return '0 Sek.';
    const m = Math.floor(totalSeconds / 60);
    const s = Math.round(totalSeconds % 60);
    if (m === 0) return `${s} Sek.`;
    if (s === 0) return `${m} Min.`;
    return `${m} Min. ${s} Sek.`;
  };

  const itemCount = (statableItem?.items || []).length;
  const hasSubStream = (statableItem?.items || []).some(
    (it) => it?.element_type === 'stream',
  );

  return (
    <Page
      pageClass="stream-page"
      mainContentClass="streams-page__r2"
      pageTitle={
        isNew ? 'Stream Erstellen' : 'Stream bearbeiten'
      }>
      <Loading active={isLoading || isSaving || isCreating} withOverlay={true} />
      <Row>
        <Column lg={5} md={2} className="elements-page__main">
          <StreamListItem
            streamId={currentId}
            elements={statableItem.items || []}
            refreshElements={refreshElements}
            orientation={
              statableItem.orientation ? statableItem.orientation : 0
            }
            onEditStreamItem={editStreamItem}
          />
        </Column>

        <Column lg={11} md={6} className="stream-page__sideform">
          <Row>
            <Column lg={16}>
              <Row>
                <Column lg={7} className="preview_container__column">
                  <div className="preview_container__inner">
                    <PreviewSlideshow
                      size="big"
                      elements={statableItem.items || []}
                      orientation={
                        statableItem.orientation ? statableItem.orientation : 0
                      }
                      nowebgl={isSafari}
                    />
                  </div>
                </Column>
                <Column lg={9} className="info-card">
                  <Tile>
                    <h4 className="info-card__heading">Informationen zum Stream</h4>
                    <p className="info-card__body">
                      Du stellst hier zusammen, was auf deinen Bildschirmen
                      laufen soll. Über das <b>Plus</b> zwischen den Kacheln
                      fügst du neue Elemente ein. Die Reihenfolge bestimmst
                      du über die kleinen <b>Pfeil-Buttons</b> am rechten
                      Rand jedes Elements — einzeln nach oben/unten oder
                      direkt ganz nach vorn oder ans Ende.
                    </p>
                    <p className="info-card__body">
                      Ein Element kann auch ein <b>weiterer Stream</b> sein
                      (Stream-in-Stream): so verpackst du eine ganze
                      Sequenz in eine Kachel und kannst dieselbe Sequenz
                      in mehreren Streams wiederverwenden. Änderst du sie
                      später, ändert sich's überall mit.
                    </p>
                    <p className="info-card__body">
                      Manche Elemente sind <b>Varianten</b> desselben
                      Motivs — zum Beispiel ein Layout in unterschiedlichen
                      Preisstufen oder mit verschiedenen Datumsangaben.
                      Direkt unter so einer Kachel erscheint ein
                      Auswahlfeld, über das du jederzeit eine andere
                      Variante wählst, ohne das Element neu hinzufügen zu
                      müssen.
                    </p>
                    <p className="info-card__body">
                      Aktuell:&nbsp;
                      <b>{itemCount}</b>&nbsp;{itemCount === 1 ? 'Element' : 'Elemente'}
                      {hasSubStream && <> (davon mind. ein eingebetteter Stream)</>}
                      , geschätzte Abspieldauer pro Durchlauf
                      &nbsp;<b>{formatDuration(estimatedDurationSeconds)}</b>.
                    </p>
                    <p className="info-card__body">
                      Erstellt&nbsp;
                      <b>{statableItem?.model?.updated_at ? moment(statableItem.model.created_at).locale('de').fromNow() : "-/-"}</b>,
                      zuletzt bearbeitet&nbsp;
                      <b>{statableItem?.model?.updated_at ? moment(statableItem.model.updated_at).locale('de').fromNow(): "noch nie"}</b>.
                    </p>
                  </Tile>
                </Column>
              </Row>

              <Row>
                <Column>
                  <Tabs>
                    <TabList aria-label="Stream-Settings-Tab" contained>
                      <Tab id="tab_default">Allgemein</Tab>
                      <Tab id="tab_links">Zuordnungen</Tab>
                      <Tab id="tab_advanced">Erweitert</Tab>
                    </TabList>
                    <TabPanels>
                      <TabPanel className="tab-content">
                        <Form>
                          <FormGroup legendText="">
                            <TextInput
                              labelText="Name"
                              id="form_stream_name"
                              helperText=""
                              invalidText="Es muss ein Name vorhanden sein"
                              invalid={
                                !statableItem.name || statableItem.name.length < 2
                              }
                              onChange={(e) =>
                                changeFormField('name', e.target.value)
                              }
                              value={statableItem.name}
                            />
                            <TextArea
                              labelText="Beschreibung"
                              value={statableItem.notes}
                              id="form_stream_description"
                              helperText=""
                              onChange={(e) =>
                                changeFormField('notes', e.target.value)
                              }
                            />
                          </FormGroup>
                          <FormGroup legendText="Ausrichtung">
                            <RadioButtonGroup
                              name="form_stream_orientation"
                              valueSelected={statableItem.orientation + 1 || 1}
                              onChange={(e) =>
                                changeFormField('orientation', e - 1)
                              }>
                              <RadioButton
                                value={1}
                                labelText="Querformat"
                                disabled={
                                  statableItem.items?.find(
                                    (e) => {
                                      return e.element.orientation === 1
                                    }
                                  ) !== undefined
                                }
                              />
                              <RadioButton
                                value={2}
                                labelText="Hochkant Darstellung"
                                disabled={
                                  statableItem.items?.find(
                                    (e) => e.element.orientation === 0
                                  ) !== undefined
                                }
                              />
                              <RadioButton
                                value={3}
                                labelText="Multi Darstellung"
                                disabled={
                                  statableItem.items?.find(
                                    (e) =>
                                      e.element.orientation === 0 ||
                                      e.element.orientation === 1
                                  ) !== undefined
                                }
                              />
                            </RadioButtonGroup>
                          </FormGroup>
                        </Form>
                      </TabPanel>
                      <TabPanel className="tab-content">
                        <Assignments
                          assignments={
                            statableItem.devices
                              ? statableItem.devices?.map((d) => d.model.ID)
                              : []
                          }
                          onAssignmentsChanges={changeAssignments}
                        />
                      </TabPanel>
                      <TabPanel className="tab-content">
                        {isAdmin && (
                          <>
                            <Toggle
                              id="field_for_enable_or_disable_bundesliga"
                              labelB="Stream als BIG CASH Aktion verwenden"
                              labelA="Normaler Stream"
                              toggled={statableItem.action_stream || false}
                              onToggle={(_e) =>
                                changeFormField(
                                  'action_stream',
                                  !statableItem.action_stream
                                )
                              }
                            />
                            <br />

                            {statableItem.action_stream && (
                              <DatePicker
                                id="field_for_datepicker_group"
                                datePickerType="range"
                                dateFormat="d.m.Y"
                                locale="de"
                                onChange={(e) => {
                                  let s = e[0].toLocaleDateString('en-CA');
                                  changeFormField('action_stream_start', s);
                                  if (e.length > 1) {
                                    let t = e[1].toLocaleDateString('en-CA');
                                    changeFormField('action_stream_end', t);
                                  }
                                }}
                                value={[
                                  Date.parse(statableItem?.action_stream_start),
                                  Date.parse(statableItem?.action_stream_end),
                                ]}>
                                <DatePickerInput
                                  id="stream-aktions-start"
                                  placeholdr="dd.mm.yyyy"
                                  labelText="Aktions start"
                                  //pattern="\\d{4}-\\d{1,2}-\\d{1,2}"
                                />
                                <DatePickerInput
                                  id="stream-aktions-end"
                                  placeholdr="dd.mm.yyyy"
                                  labelText="Aktions ende"
                                  //pattern="\\d{1,2}.\\d{1,2}.\\d{4}"
                                />
                              </DatePicker>
                            )}
                          </>
                        )}
                        <div style={{ minHeight: '10rem' }}></div>
                        {currentId === 'new' || (
                          <Link href="#" onClick={() => removeStream()}>
                            Stream endgültig löschen
                          </Link>
                        )}
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                </Column>
              </Row>
              <Row>
                {unsaved === true || statableItem.items?.find(e => e.lazy == true) ? (
                  <Column>
                    <FormButtons
                      primaryLabel="Speichern"
                      secondaryLabel="Abbrechen"
                      onSubmit={submitForm}
                      onAbort={resetForm}
                    />
                  </Column>
                ) : (
                  <Column>
                    <SingleButton primaryLabel="Zurück" onAbort={resetForm} />
                  </Column>
                )}
              </Row>
            </Column>
          </Row>
        </Column>
      </Row>
    </Page>
  );
};

export default StreamPage;
